// ! IMAGES MUST BE IMPORTED AS ASSETS
import TrxNowLogo from "assets/logo/TrxNow_Logo_Alt_White_H.png";
import FIMCLogo from "assets/logo/FIMC_White_logo.png";
import BaZingLogo from "assets/logo/bazing.png";
//import ATTLogo from 'assets/logo/attLogo.png';
import MercuryLogo from "assets/logo/MercuryLogoWhite.png";
import TDLogo from "assets/logo/TDLogo.png";
import TVLLogo from "assets/logo/TravelersLogo.png";
import LDSLogo from "assets/logo/LDSLogo.jpg";
import HolmanLogo from "assets/logo/holmanLogo.png";
import BWCLogo from "assets/logo/BWCLogo.png";
import ATFLogo from "assets/logo/attLogo.png";
import ATTLogo from "assets/logo/attLogo.png";
import LMCLogo from "assets/logo/LMCLogo.jpg";
import MLILogo from "assets/logo/MLI.png";
import LISLogo from "assets/logo/LISLogo.jpeg";
import CRRLogo from "assets/logo/CRRLego.png";
import ECCLogo from "assets/logo/ECCLogo.png";
import R66Logo from "assets/logo/R66Logo.png";
import GMILogo from "assets/logo/GMILogo.png";
import NFILogo from "assets/logo/NFILogo.png";
import ARSLogo2 from "assets/logo/ARSLogo2.png";
import PEPLogo from "assets/logo/PepBoysLogo.png";
import PBFLLogo from "assets/logo/PBFLLogo.png";

// DEFAULT PARTNER OBJ WHERE ALL PARTNER SPECIFIC PARAMS WILL GO
export const PartnerObj = [
  {
    name: "default",
    img: TrxNowLogo,
    title: "TrxNow Roadside Assistance",
  },
  {
    name: "FIMC",
    img: FIMCLogo,
    title: "FIMC Roadside Assistance",
  },
  {
    name: "SC",
    img: BaZingLogo,
    title: "Roadside Assistance",
  },
  {
    name: "MER",
    img: MercuryLogo,
    title: "Roadside Assistance",
  },
  {
    name: "TD",
    img: TDLogo,
    title: "Roadside Assistance",
  },
  {
    name: "TVL",
    img: TVLLogo,
    title: "Travelers Roadside Assistance",
  },
  {
    name: "LDS",
    img: LDSLogo,
    title: "Roadside Assistance",
  },
  {
    name: "ARIU",
    img: HolmanLogo,
    title: "Holman Roadside Assistance",
  },
  {
    name: "ARIC",
    img: HolmanLogo,
    title: "Holman Roadside Assistance",
  },
  {
    name: "BWC",
    img: BWCLogo,
    title: "Better World Roadside Assistance",
  },
  {
    name: "ATF",
    img: ATFLogo,
    title: "AT&T Roadside Assistance",
  },
  {
    name: "ATT",
    img: ATTLogo,
    title: "AT&T Roadside Assistance",
  },
  {
    name: "LMC",
    img: LMCLogo,
    title: "Roadside Assistance",
  },
  {
    name: "MLI",
    img: MLILogo,
    title: "Roadside Assistance",
  },
  {
    name: "LIS",
    img: LISLogo,
    title: "Roadside Assistance",
  },
  {
    name: "CRR",
    img: CRRLogo,
    title: "Roadside Assistance",
  },
  {
    name: "ECC",
    img: ECCLogo,
    title: "Roadside Assistance",
  },
  {
    name: "R66",
    img: R66Logo,
    title: "Roadside Assistance",
  },
  {
    name: "GMI",
    img: GMILogo,
    title: "Roadside Assistance",
  },
  {
    name: "NFI",
    img: NFILogo,
    title: "Roadside Assistance",
  },
  {
    name: "ARS",
    img: ARSLogo2,
    title: "Roadside Assistance",
  },
  {
    name: "CSOS",
    img: ARSLogo2,
    title: "CurbsideSOS Roadside Assistance",
  },
  {
    name: "PEP",
    img: PEPLogo,
    title: "Roadside Assistance",
  },
  {
    name: "PBFL",
    img: PBFLLogo,
    title: "Roadside Assistance",
  },
];

//PARTNER FINDER FUNCTION BASED OFF THE localGroupLogo value that is found in the WebAppView
export const FindPartner = (inputText) => {
  var finalVal = "";
  //console.log(inputText)
  PartnerObj.map((item) => {
    if (item.name === inputText) {
      finalVal = item;
    }
    return null;
  });
  //console.log(finalVal)
  if (finalVal === "") {
    return PartnerObj[0].img;
  } else {
    return finalVal.img;
  }
};
